import PropTypes from 'prop-types';
import React from 'react';

import { userProfileShape } from '../../proptypes';

// TODO: Change name of other export. The non-default
// version is exported for testing. Sigh.
// eslint-disable-next-line import/no-named-as-default
import UserMenuLoggedIn from './components/UserMenuLoggedIn';
import UserMenuLoggedOut from './components/UserMenuLoggedOut';

/**
 * User menu presentational component.
 * Renders with logged in or logged out user menu.
 */
const UserMenu = ({ className, onLinkClick, profile, ...props }) => {
  if (profile) {
    return (
      <UserMenuLoggedIn className={className} profile={profile} {...props} />
    );
  }
  return (
    <UserMenuLoggedOut
      className={className}
      onLinkClick={onLinkClick}
      {...props}
    />
  );
};

UserMenu.propTypes = {
  /**
   * String class names to append to component styles.
   */
  className: PropTypes.string,
  /**
   * The locale the user has selected, if any
   */
  userSelectedLocale: PropTypes.string,
  /**
   * Boolean describing user autenticated state.
   */
  loggedIn: PropTypes.bool,
  /**
   * Function called on link click.
   */
  onLinkClick: PropTypes.func,
  /**
   * Normalized user profile object, when user is logged in
   */
  profile: userProfileShape,
};

UserMenu.defaultProps = {
  className: '',
  userSelectedLocale: undefined,
  loggedIn: false,
  onLinkClick: () => {},
  profile: null,
};

export default UserMenu;
